import React from "react";
import B2BLeadDetail from "@/pages/coe/B2BLeadDetail";

/* Admin shell for B2B lead detail — reuses the COE detail with scope="admin".
   Path B Phase 3 (2026-02-25). scope="admin" enables the Reassign button and
   suppresses sales-rep-only actions; everything else is identical. */
export default function AdminB2BLeadDetail() {
    return <B2BLeadDetail scope="admin" />;
}
